import { GeoLocationStatus } from '@endeavour/enhanced-geo-integration';
import { GeoLocationError } from '@endeavour/enhanced-geo-integration/src/interface/errors.interface';
import { convertStatus, convertError } from './util.js';

const handleError = (error) => {
    console.log(error, 'Handle error');
    if (error && error.message === 'Local service is not launched') {
        return {
            status: GeoLocationStatus.DENIED,
            errors: [GeoLocationError.SOFTWARE_NOT_RUNNING],
            token: '',
        };
    }
    throw error;
};
const createSportNCoNativeXPointIntegration = (origin) => {
    const decodeToken = (token) => {
        console.log(token, 'decode token');
        const [_, payload] = token.split('.');
        return JSON.parse(atob(payload));
    };
    let lastToken = undefined;
    console.log(lastToken, 'LAST TOKEN');
    const listeners = [];
    const messageHandler = (event) => {
        if (!event.data || event.data.message !== 'sportnco_send_geo_token') {
            console.log(event, 'sportnco send geo token event issue');
            return;
        }
        const { token } = event.data.args;
        console.log(token, 'token correctly passed from the integration');
        if (token) {
            console.log(token, 'token is the same');
            lastToken = token;
        }
        if (!lastToken) {
            return;
        }
        const decodedToken = decodeToken(lastToken);
        console.log(decodedToken, 'decoded token');
        listeners.forEach((listener) => {
            try {
                listener({
                    token: lastToken,
                    status: convertStatus(decodedToken.data.status),
                    errors: (decodedToken.data.errors ?? []).map((error) => {
                        return convertError(error);
                    }),
                });
            }
            catch (e) {
                console.error('Error occurred when calling geolocation listener', e, listener);
            }
        });
    };
    return {
        isVerifyRunning() {
            return new Promise((resolve) => {
                // Perform some asynchronous logic to determine if verification is running
                // For example, check the status of a verification process
                resolve(true);
            });
        },
        async startLocationCheck() {
            // Inform the parent app we're ready to receive location data
            console.log('STARTING LOCATION CHECK');
            window.parent.postMessage({ message: 'external_geolocation_iframe_ready' }, origin);
            // Subscribe to events
            window.addEventListener('message', messageHandler);
        },
        async endLocationCheck() {
            window.removeEventListener('message', messageHandler);
        },
        getCurrentToken() {
            return lastToken;
        },
        getTokenExpiryTimestamp() {
            if (!lastToken) {
                return 0;
            }
            return +decodeToken(lastToken).exp;
        },
        async getDetectedLocationInformation() {
            try {
                if (!lastToken) {
                    return {
                        status: GeoLocationStatus.PENDING,
                        errors: [],
                    };
                }
                const decodedToken = decodeToken(lastToken);
                return {
                    token: lastToken,
                    status: convertStatus(decodedToken.data.status),
                    errors: (decodedToken.data.errors ?? []).map((error) => {
                        return convertError(error);
                    }),
                };
            }
            catch (e) {
                return handleError(e);
            }
        },
        onLocationRefreshed(handler) {
            listeners.push(handler);
            return () => {
                const index = listeners.indexOf(handler);
                if (index > -1) {
                    listeners.splice(index, 1);
                }
            };
        },
    };
};

export { createSportNCoNativeXPointIntegration };
